// extracted by mini-css-extract-plugin
export default {"layout":"src-components-AppLayout-index-module_layout--aN8Um","content-wraper":"src-components-AppLayout-index-module_content-wraper--I0nbV"};